import { useTranslation } from 'react-i18next';
import { navigateToWorkbench } from 'app/routes';
import { Snackbar, SnackbarMessage, SnackbarVariant } from 'app/components/core/Snackbar';
import { ShowDetailsButton } from 'app/components/features/NotificationHub/ShowDetailsButton.jsx';

export function AnalyzeSchemaUsageSuccessNotification({
    id,
    type,
    onDismiss,
    projectName,
    projectSlug,
    schemaToAnalyze,
    resultTable
}) {
    const { t } = useTranslation();

    const handleClickDetails = () => {
        navigateToWorkbench(projectSlug);
    };

    return (
        <Snackbar id={id} onDismiss={onDismiss} variant={SnackbarVariant.SUCCESS}>
            <SnackbarMessage>
                {t(`notifications:${type}`, {
                    projectName,
                    schemaName: schemaToAnalyze.schema,
                    tableName: resultTable.table
                })}
            </SnackbarMessage>
            <ShowDetailsButton
                i18nKey="notifications:analyzeSchemaUsageDetailsButton"
                onClick={handleClickDetails}
            />
        </Snackbar>
    );
}
